import { Component, OnInit } from "@angular/core";
import { Utility } from "src/app/shared/services/utility.service";
import { NavigationStart, Router } from "@angular/router";

@Component({
  selector: "vex-aml",
  templateUrl: "./aml.component.html",
  styleUrls: ["./aml.component.scss"],
})
export class AmlComponent implements OnInit {
  remitters: any[] = [];
  title = "Remitter Verification";
  constructor(private router: Router) {
    this.router.events.subscribe((e) => {
      if (e instanceof NavigationStart) {
        if (e.url.includes("ben")) {
          this.title = "Beneficiary Verification";
        } else {
          this.title = "Remitter Verification";
        }
      }
    });
  }

  ngOnInit(): void {
    
  }

  approve(rem) {
    Utility.getConfirmation(
      "You are about to approve " + rem.fullname + " as a valid remitter. Click 'Yes' to continue",
      () => {}
    );
  }
}
